import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import { checkIsActive } from '@helpers';

type Props = {
    to: string;
    title: string;
    icon?: string;
    fontIcon?: string;
    hasBullet?: boolean;
    children?: React.ReactNode;
    visible?: boolean;
};

const SideMenuItem: React.FC<Props> = ({ children, to, title, fontIcon, hasBullet = false, visible = true }) => {
    const location = useLocation();
    const isActive = checkIsActive(location.pathname, to);

    if (!visible) {
        return null;
    }

    return (
        <div className="menu-item">
            <Link className={classnames('menu-link without-sub', { active: isActive })} to={to}>
                {hasBullet && (
                    <span className="menu-bullet">
                        <span className="bullet bullet-dot" />
                    </span>
                )}
                {fontIcon && <i className={classnames('bi fs-3', fontIcon)} />}
                <span className="menu-title">{title}</span>
            </Link>
            {children}
        </div>
    );
};

export { SideMenuItem };
